import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button } from "components/Button/Button";
import { Input } from "components/Form";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import ReactSelect from "react-select";
import { dateFormat, formatDateForInput, simpleDateForma2, simpleDateFormat } from "utils";
import { getCourseCategory } from "services/master";
import { useLocation, useParams } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import { Checkbox } from "@mui/material";
import IconButton from '@mui/material/IconButton';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; // Assign User
import {
  getactivecourseskyc,
  getactivecoursesoftablet,
  getkycstudents,
} from "services/KYC/KYCcontroller";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import { getExceptionalMobileCourses, assignStudentExpMobileCourses, deleteStudentExpMobileCourses, deleteforallStudentExpMobileCourses } from "services/student/studentController";
import ModalBox from "components/modal/ModalBox";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

const ExceptionalMobileCourses = () => {
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
  const [allCourseTypes, setAllCourseTypes] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [selectedCourseType, setSelectedCourseType] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedCourseEndDate, setSelectedCourseEndDate] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const location = useLocation();
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmModal1, setShowConfirmModal1] = useState(false);
  const [showConfirmModal2, setShowConfirmModal2] = useState(false);
  const [showAssignedOnly, setShowAssignedOnly] = useState(false);
  const [editingStudentId, setEditingStudentId] = useState(null);
  const [editExpireDate, setEditExpireDate] = useState("");



  //********************************** Perform action on window load ******************************************* */
  useLayoutEffect(() => {
    window.addEventListener("load", () => {
      setUserEmail("");
      setSelectedCourse("");
    });
  }, []);
  // 
  // ****************************** Fetch Data on backtrack *************************************


  // Pagination handler
  const paginationHandler = (page) => {
    setActivePage(page);
    getExceptionalMobileCoursesStudents(page);
  };

  const resetFilter = () => {
    setRecord([]);   // <-- clears UI immediately
    setTotal(0);

    setUserEmail("");
    setSelectedCourse("");


  };

  // Get KYC students based on filters
  const getExceptionalMobileCoursesStudents = async (page = 1, assignflag, data) => {
    try {
      showLoader();
      const res = await getExceptionalMobileCourses({
        courseid: selectedCourse?.value || data?.value,
        search: userEmail,
        assignFlag: assignflag !== undefined ? assignflag : showAssignedOnly ? "Yes" : "", // <-- use showAssignedOnly if assignflag not passed
        page,
      });
      hideLoader();

      if (res.code === 200) {
        const students = res.data.students?.rows || [];
        const totalStudents = res.data.students?.count || 0;
        setRecord(students);
        setTotal(totalStudents);
        setSelectedCourseEndDate(res.data?.students?.courseendDate || "");

        // Update the checkbox if no assigned students exist
        if (!showAssignedOnly && res.data.students?.count === 0) {
          setShowAssignedOnly(false);
        }
      } else if (res.code === 100) {
        toast.error("No Data Found");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };


  const getDefaultExpireDate = (courseEndDate) => {
    if (!courseEndDate) return "";

    const today = new Date();
    const oneMonthLater = new Date();
    oneMonthLater.setMonth(today.getMonth() + 1);

    const endDate = new Date(courseEndDate);

    const finalDate =
      oneMonthLater > endDate ? endDate : oneMonthLater;

    return finalDate.toISOString().split("T")[0];
  };



  const assignSelectedStudentsExpCourses = async () => {
    try {
      // 🔴 Validation 1: check expire date selected
      const missingDateStudent = selectedStudents.find(
        (s) => !s.accessDate
      );

      if (missingDateStudent) {
        toast.error("Please select expiry date for all selected students");
        return;
      }

      // 🔴 Validation 2: check date <= course end date (extra safety)
      const invalidDateStudent = selectedStudents.find(
        (s) =>
          new Date(s.accessDate) >
          new Date(selectedCourseEndDate)
      );

      if (invalidDateStudent) {
        toast.error(
          "Expiry date cannot be greater than course end date"
        );
        return;
      }

      setSubmitLoading(true);

      const payload = {
        courseid: selectedCourse?.value,
        users: Array.from(
          new Map(
            selectedStudents.map(s => [
              s.userId,
              { studentid: s.userId, accessDate: s.accessDate }
            ])
          ).values()
        ),
      };


      const res = await assignStudentExpMobileCourses(payload);

      setSubmitLoading(false);

      if (res.code === 200) {
        toast.success("Students successfully assigned to mobile course!");

        getExceptionalMobileCoursesStudents(activePage);
        closeModal();
      } else {
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      setSubmitLoading(false);
      toast.error(err?.response?.data?.message || err.message);
    }
  };


  const handleUnassignAll = async () => {
    try {
      showLoader();

      const payload = {
        courseid: selectedCourse?.value,
      };

      const res = await deleteforallStudentExpMobileCourses(payload);

      hideLoader();

      if (res.code === 200) {
        toast.success("All students unassigned successfully!");
        getExceptionalMobileCoursesStudents(1, "");
        setShowAssignedOnly(false);
        closeModal2();
      } else {
        toast.error(res.message);
        closeModal2();
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
      closeModal2();
    }
  };


  const onChangeHandler = (data) => {
    setSelectedCourse(data);
  };

  React.useLayoutEffect(() => {
    const getAllActiveCourses = async () => {
      try {
        showLoader();
        const res = await getactivecoursesoftablet();
        hideLoader();

        if (res.code === 200) {
          setAllCourses(
            res.data.courses?.map((data) => {
              return { label: data.CourseTitle, value: data.CourseID };
            }) || []
          );
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        hideLoader();
        toast.error(err?.response?.data?.message || err.message);
      }
    };

    getAllActiveCourses();
  }, []);

  const checkUncheckAll = () => {
    if (selectedStudents.length === selectableStudents.length) {
      setSelectedStudents([]);
    } else {
      const defaultDate = getDefaultExpireDate(selectedCourseEndDate);

      const unique = selectableStudents.map((item) => ({
        userId: item.UserID,
        accessDate: defaultDate,
      }));

      setSelectedStudents(unique);
    }
  };






  const checkHandler = (id) => {
    setSelectedStudents((prev) => {
      const map = new Map(prev.map((s) => [s.userId, s]));

      if (map.has(id)) {
        map.delete(id);
      } else {
        map.set(id, {
          userId: id,
          accessDate: getDefaultExpireDate(selectedCourseEndDate),
        });
      }

      return Array.from(map.values());
    });
  };




  const closeModal = () => {
    setShowConfirmModal(false)
    setSelectedStudents([]);
  }
  const closeModal1 = () => {
    setShowConfirmModal1(false)
    setSelectedStudent(null)
    setSelectedStudents([]);
  }
  const closeModal2 = () => {
    setShowConfirmModal2(false)
    setSelectedStudent(null)
    setSelectedStudents([]);
  }


  useEffect(() => {
    setSelectedStudents([]);
  }, [record]);

  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleUnassign = async () => {
    try {
      const student = selectedStudent;
      if (!student) return;

      showLoader();

      const payload = {
        courseid: selectedCourse?.value,
        studentid: student?.UserID,
      };

      const res = await deleteStudentExpMobileCourses(payload);

      hideLoader();

      if (res.code === 200) {
        toast.success(`${student.firstName} has been unassigned successfully!`);

        // refresh data
        getExceptionalMobileCoursesStudents(activePage);
        setSelectedStudent(null)

        closeModal1();
      } else {
        closeModal1();
        setSelectedStudent(null)
        toast.error(res.message || "Something went wrong!");
      }
    } catch (err) {
      closeModal1();
      setSelectedStudent(null)
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  const handleSearch = () => {
    setShowAssignedOnly(false)
    if (!selectedCourse) {
      toast.error("Please select a course first!");
      return;
    }

    setActivePage(1);
    getExceptionalMobileCoursesStudents(1, selectedCourse);
  };


  const selectableStudents = record.filter(
    (item) => !item.hasExpMobileCourse
  );

  const isAssignDisabled =
    selectedStudents.length === 0 ||
    selectedStudents.some((s) => !s.accessDate);

  const handleEditClick = (student) => {
    setEditingStudentId(student.UserID);
    setEditExpireDate(student.expireDate || "");
  };

  const assignEditedStudent = async (date) => {
    try {
      if (!date) {
        toast.error("Please select expiry date");
        return;
      }
      if (new Date(date) > new Date(selectedCourseEndDate)) {
        toast.error("Expiry date cannot be greater than course end date");
        return;
      }

      setSubmitLoading(true);

      const payload = {
        courseid: selectedCourse?.value,
        type: "edit",
        users: [
          {
            studentid: editingStudentId,
            accessDate: date,
          },
        ],
      };

      const res = await assignStudentExpMobileCourses(payload);
      setSubmitLoading(false);

      if (res.code === 200) {
        toast.success("Expiry date updated successfully!");
        setEditingStudentId(null);
        setEditExpireDate("");

        // 🔹 Pass the showAssignedOnly state when refetching
        getExceptionalMobileCoursesStudents(activePage, showAssignedOnly ? "Yes" : "");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      setSubmitLoading(false);
      toast.error(err?.response?.data?.message || err.message);
    }
  };




  return (
    <React.Fragment>
      <title>Shubhra Viraj | Student Mobile Course Access</title>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="SearchBox"></div>
              <h4 className="Title">Student Mobile Course Access</h4>
            </div>
            <div className="SearchBox mt-3" style={{ width: "100%" }}>
              <div className="row w-100">
                <div
                  className="col-sm-12 d-flex align-items-center"
                  style={{ gap: "15px" }}
                >
                  {/* Course Selection - 30% */}
                  <div style={{ width: "30%" }}>
                    <ReactSelect
                      className="w-100 react-select"
                      placeholder="Select Course"
                      options={allCourses}
                      value={selectedCourse}
                      onChange={onChangeHandler}
                      isSearchable={true}
                    />
                  </div>

                  {/* Search Input - reduced width 32% */}
                  <div style={{ width: "32%" }}>
                    <input
                      type="text"
                      placeholder="Enter Email / Mobile"
                      className="form-control"
                      name="search"
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "8px 14px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                      }}
                    />
                  </div>

                  {/* Search Button - placed right beside input */}
                  <Button
                    onClick={handleSearch}
                    style={{
                      width: "90px",
                      height: "42px",
                    }}
                  >
                    Search
                  </Button>

                  {/* Reset Button */}
                  <Button
                    className="refresh_btnn"
                    onClick={resetFilter}
                    style={{
                      height: "42px",
                      width: "42px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <i className="fa fa-refresh"></i>
                  </Button>
                </div>
              </div>
            </div>


            <hr className="border border-danger" />

            {record.length > 0 && (

              <div
                className="d-flex align-items-center mb-2"
                style={{ justifyContent: "space-between", width: "100%" }}
              >
                {/* LEFT SIDE */}
                <div className="d-flex align-items-center">
                  <Checkbox
                    sx={{
                      transform: "scale(1.2)",
                      "& .MuiSvgIcon-root": { fontSize: 20, color: "#4971b2" },
                      padding: 0,
                    }}
                    checked={showAssignedOnly}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setShowAssignedOnly(checked);
                      getExceptionalMobileCoursesStudents(1, checked ? "Yes" : "");
                    }}
                  />


                  <span style={{ marginLeft: "8px" }}>Show All Assigned</span>

                  <span style={{ marginLeft: "12px", fontWeight: "600" }}>Selected Course End Date: (<span style={{ color: "#4971b2" }}>{dateFormat(selectedCourseEndDate)}</span>)</span>
                </div>

                {selectedStudents.length > 0 && (
                  <div className="mt-3" style={{ textAlign: "right", marginRight: "20px" }}>
                    <Button
                      className="mx-2"
                      onClick={() => setShowConfirmModal(true)}
                      {...submitButtonElement2}
                      disabled={isAssignDisabled}
                    >
                      Assign Course
                    </Button>

                  </div>
                )}

                {/* RIGHT SIDE */}
                {showAssignedOnly && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      color: "red",
                      padding: "4px 11px",
                      fontSize: "0.85rem",
                      border: "1px solid red"
                    }}
                    onClick={() => setShowConfirmModal2(true)}
                  >
                    Remove Access for all student
                  </Button>
                )}
              </div>


            )}
            {loader}
            <div className="row mt-3">
              <div className="col-sm-12">
                <div className="TableList overflow-auto table-responsive p-0">
                  <table className="position-relative">
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }}>
                          {record.length > 0 && (
                            <Checkbox
                              size="small"
                              sx={{
                                padding: "0",
                                "& .MuiSvgIcon-root": { color: "#e14177" },
                              }}
                              onChange={checkUncheckAll}
                              checked={
                                selectableStudents.length > 0 &&
                                selectedStudents.length === selectableStudents.length
                              }
                              indeterminate={
                                selectedStudents.length > 0 &&
                                selectedStudents.length < selectableStudents.length
                              }
                            />

                          )}
                        </th>
                        <th>S.No</th>
                        <th>Student Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Expiry Date</th>
                        <th>Action</th> {/* New column */}
                      </tr>
                    </thead>

                    <tbody>
                      {!loader &&
                        record.map((student, index) => {
                          const id = student.UserID;
                          const isAlreadyAssigned = student.hasExpMobileCourse;

                          return (
                            <tr key={id} style={{ opacity: isAlreadyAssigned ? 0.9 : 1 }}>
                              <td>
                                <Checkbox
                                  size="small"
                                  sx={{
                                    padding: "0",
                                    "& .MuiSvgIcon-root": {
                                      color: isAlreadyAssigned ? "#9e9e9e" : "red",
                                    },
                                  }}
                                  checked={
                                    isAlreadyAssigned ||
                                    selectedStudents.some((s) => s.userId === id)
                                  }
                                  disabled={isAlreadyAssigned}
                                  onChange={() => checkHandler(id)}
                                />
                              </td>
                              <td>{index + 1 + (activePage - 1) * 10}</td>
                              <td>{`${student.firstName} ${student.middleName || ""} ${student.lastName}`}</td>
                              <td>{student.EmailID}</td>
                              <td>{student.Mobile}</td>

                              {/* Expire Date Column */}
                              <td>
                                {isAlreadyAssigned ? (
                                  editingStudentId === id ? (
                                    <Input
                                      type="date"
                                      style={{ backgroundColor: "#e9ecef" }}
                                      className="form-control"
                                      value={editExpireDate}
                                      max={formatDateForInput(selectedCourseEndDate)}
                                      onChange={(e) => setEditExpireDate(e.target.value)}
                                    />
                                  ) : (
                                    <span>{student.expireDate ? dateFormat(student.expireDate) : "N/A"}</span>
                                  )
                                ) : selectedStudents.some((s) => s.userId === id) ? (
                                  <Input
                                    type="date"
                                    style={{ backgroundColor: "#e9ecef" }}
                                    className="form-control"
                                    value={selectedStudents.find((s) => s.userId === id)?.accessDate || ""}
                                    max={formatDateForInput(selectedCourseEndDate)}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      setSelectedStudents((prev) =>
                                        prev.map((s) =>
                                          s.userId === id ? { ...s, accessDate: value } : s
                                        )
                                      );
                                    }}
                                  />
                                ) : (
                                  <span style={{ color: "#999" }}>N/A</span>
                                )}
                              </td>

                              {/* Action Column */}
                              <td>
                                {isAlreadyAssigned ? (
                                  editingStudentId === id ? (
                                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                      {/* Update button */}
                                      <Button
                                        style={{ padding: "3px 10px", fontSize: "0.8rem", backgroundColor: "#4971b2", color: "white" }}
                                        onClick={() => assignEditedStudent(editExpireDate)}
                                      >
                                        Update
                                      </Button>

                                      {/* Cancel button */}
                                      <IconButton
                                        aria-label="cancel"
                                        className="px-1 py-0"
                                        onClick={() => {
                                          setEditingStudentId(null);
                                          setEditExpireDate("");
                                        }}
                                      >
                                        <CloseIcon sx={{ color: "#4a4a4aff" }} />
                                      </IconButton>
                                    </div>
                                  ) : (
                                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                      {/* Edit icon */}
                                      {student.expireDate && (
                                        <IconButton
                                          aria-label="edit"
                                          className="px-1 py-0"
                                          onClick={() => handleEditClick(student)}
                                        >
                                          <EditIcon sx={{ color: "#4971B2" }} />
                                        </IconButton>
                                      )}

                                      {/* Unassign button */}
                                      <Button
                                        style={{
                                          border: "1px solid red",
                                          color: "red",
                                          backgroundColor: "transparent",
                                          padding: "3px 10px",
                                          fontSize: "0.8rem",
                                        }}
                                        onClick={() => {
                                          setSelectedStudent(student);
                                          setShowConfirmModal1(true);
                                        }}
                                      >
                                        Unassign
                                      </Button>
                                    </div>
                                  )
                                ) : (
                                  <span>-</span>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>




                  </table>
                  {!loader && !record.length && (
                    <div>
                      <center>
                        <NotFound />
                      </center>
                    </div>
                  )}
                </div>
                <div>
                  {total > 10 ? (
                    <div className="Pagination">
                      <Pagination
                        activePage={activePage}
                        previousLabel={"previous"}
                        nextLabel={"next"}
                        itemsCountPerPage={10}
                        totalItemsCount={total}
                        pageRangeDisplayed={5}
                        onChange={(page) => {
                          paginationHandler(page);
                        }}
                      />
                    </div>
                  ) : null}



                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalBox
          status={showConfirmModal}
          onClose={closeModal}
          title={"Assign Course"}
          size={"sm"}
          description={"Are you sure want to allow it for mobile platform ?"}
          custom={false}
          customizedFooter={
            <Button {...submitButtonElement} onClick={assignSelectedStudentsExpCourses}>
              Yes
            </Button>
          }
        />
        <ModalBox
          status={showConfirmModal1}
          onClose={closeModal1}
          title={"Unassign Course"}
          size={"sm"}
          description={"Are you sure you want to remove mobile access for this student?"}
          custom={false}
          customizedFooter={
            <Button {...submitButtonElement} onClick={handleUnassign}>
              Yes
            </Button>
          }
        />

        <ModalBox
          status={showConfirmModal2}
          onClose={closeModal2}
          title={"Unassign All Students"}
          size={"sm"}
          description={"Are you sure you want to remove mobile access for all students?"}
          custom={false}
          customizedFooter={
            <Button {...submitButtonElement2} onClick={handleUnassignAll}>
              Yes
            </Button>
          }
        />



      </div>

    </React.Fragment >
  );
};

export default ExceptionalMobileCourses;
